module.exports = __webpack_public_path__ + "static/media/V0.bb794e09.png";